import { dispatchPromise, fetchResources } from './action-helpers';

import { getInitials } from '../utils/helpers';

export const fetchUsers = all => fetchResources('USERS_FETCH_REQUESTED', { limit: 50 }, all);

export const fetchUser = userId => {
    return dispatchPromise({
        type: 'USER_FETCH_REQUESTED',
        payload: { userId }
    });
}

export const fetchCurrentUser = masterUser => {
    return dispatchPromise({
        type: 'CURRENT_USER_FETCH_REQUESTED',
        payload: { masterUser }
    });
}

export const fetchSubscriptions = () => {
    return dispatchPromise({
        type: 'SUBSCRIPTIONS_FETCH_REQUESTED'
    });
}

export const updateCurrentUser = (userProps, preventSave) => {
    if (userProps.name) {
        userProps.initials = getInitials(userProps.name);
    }

    return dispatchPromise({
        type: 'CURRENT_USER_UPDATE_REQUESTED',
        payload: { userProps },
        preventSave
    });
}

export const updateCurrentUserPassword = userProps => {
    return dispatchPromise({
        type: 'CURRENT_USER_UPDATE_PASSWORD_REQUESTED',
        payload: { userProps }
    });
}

export const updateCurrentUserEmail = userProps => {
    return dispatchPromise({
        type: 'CURRENT_USER_UPDATE_EMAIL_REQUESTED',
        payload: { userProps }
    });
}

export const setNotificationSetting = notificationSetting => {
    return dispatchPromise({
        type: 'NOTIFICATION_SETTING_SET_REQUESTED',
        payload: { notificationSetting }
    });
}

export const removeNotificationSetting = notificationSetting => {
    return dispatchPromise({
        type: 'NOTIFICATION_SETTING_REMOVE_REQUESTED',
        payload: { notificationSetting }
    });
}

export const updateUser = (userId, userProps) => {
    return dispatchPromise({
        type: 'USER_UPDATE_REQUESTED',
        payload: {
            userId,
            userProps
        }
    });   
}

export const resendInvite = (userId, projectId) => {
    return dispatchPromise({
        type: 'USER_INVITE_RESEND_REQUESTED',
        payload: {
            userId,
            projectId
        }
    });   
}

export const addUserLabel = (userId, labelId) => {
    return addUserLabels(userId, [labelId]);
}

export const addUserLabels = (userId, labels) => {
    return dispatchPromise({
        type: 'USER_LABELS_ADD_REQUESTED',
        payload: {
            userId,
            labels
        }
    });
}

export const removeUserLabel = (userId, labelId) => {
    return removeUserLabels(userId, [labelId])
}

export const removeUserLabels = (userId, labels) => {
    return dispatchPromise({
        type: 'USER_LABELS_REMOVE_REQUESTED',
        payload: {
            userId,
            labels
        }
    });
}

export const removeUser = (userId, projectId, projectsOnly) => {
    return dispatchPromise({
        type: 'USER_REMOVE_REQUESTED',
        payload: {
            userId,
            projectId,
            projectsOnly
        }
    });   
}
